import React from 'react';
import { Modal } from '../common/Modal';
import { ProductForm } from './ProductForm';
import { ProductFormData, Product } from '../../types/Product';

interface ProductModalProps {
  open: boolean;
  onClose: () => void;
  onSave: (data: ProductFormData) => void;
  product?: Product;
  loading?: boolean;
}

export const ProductModal: React.FC<ProductModalProps> = ({
  open,
  onClose,
  onSave,
  product,
  loading,
}) => {
  const formRef = React.useRef<HTMLFormElement>(null);

  const handleSave = () => {
    if (formRef.current) {
      formRef.current.requestSubmit();
    }
  };

  const handleSubmit = (data: ProductFormData) => {
    onSave(data);
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      onSave={handleSave}
      title={product ? 'Ürün Düzenle' : 'Yeni Ürün Ekle'}
      loading={loading}
    >
      <ProductForm
        initialData={product}
        onSubmit={handleSubmit}
        loading={loading}
        formRef={formRef}
      />
    </Modal>
  );
};

